import gql from "graphql-tag";

export const MY_VERTICALS_MApp_PULSE_CHECK = gql`
  query myVerticalMAppPulseCheck {
    myVerticalMAppPulseCheck
  }
`;
